import React, { Component } from "react";
import TutorAvailability from "./TutorAvailability";
class Availability extends Component {
  render() {
    return <TutorAvailability />;
  }
}

export default Availability;
